import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Input, Card } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  keywords: {
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
  searchIcon: {
    color: theme.palette.icon,
    marginRight: theme.spacing(2),
  },
}));

const SearchBar = ({ className, selector, setSearchText, hitEnter, ...rest }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleInputChange = (event) => {
    event.persist();

    if (event.target.value === '') {
      setSearchText('');
    } else {
      setSearchText(event.target.value);
    }
  };

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <div className={classes.keywords}>
        <SearchIcon className={classes.searchIcon} />
        <Input
          className={classes.root}
          disableUnderline
          onChange={handleInputChange}
          placeholder={t('search')}
          value={selector}
          onKeyDown={(event) => {
            event.key === 'Enter' && hitEnter ? hitEnter() : undefined;
          }}
        />
      </div>
    </Card>
  );
};

SearchBar.propTypes = {
  className: PropTypes.string,
  selector: PropTypes.string.isRequired,
  setSearchText: PropTypes.func.isRequired,
  hitEnter: PropTypes.func,
};

SearchBar.defaultProps = {
  className: undefined,
  hitEnter: undefined,
};
export default SearchBar;
